import alert from "./alert.svg";

export default function AlertIcon({ width, height }) {
  return (
    <img src={alert} width={width} height={height} />
  );
}